<div [ngClass]="toggleState ? 'sidebar-filter right sidebar-product' : 'sidebar sidebar-product'">
    <div [ngClass]="toggleState ? 'sidebar-filter-wrapper product-sidebar-wrapper' : ''">
        <related-products-two [products]="products"></related-products-two>

        <div class="widget widget-banner-sidebar pb-2">
            <div class="banner-sidebar-title">ad box 280 x 280</div>

            <div class="banner-sidebar text-left banner-overlay ml-0">
                <a routerLink="/shop/sidebar/4cols" class="w-100">
                    <molla-image src="assets/images/blog/sidebar/banner.jpg" alt="banner"></molla-image>
                </a>

                <div class="banner-content text-left pt-0">
                    <p class="mb-1">online & in-store</p>
                    <h3 class="banner-subtitle text-uppercase">Spring Sale</h3>
                    <h2 class="banner-title">Up to 60% off<br />from €55</h2>
                    <a routerLink="/shop/sidebar/3cols"
                        class="btn btn-outline btn-md btn-outline-white text-uppercase m-0">Shop Now</a>
                </div>
            </div>
        </div>
    </div>
</div>

<button class="sidebar-fixed-toggler right" (click)="toggleSidebar()" *ngIf="toggleState">
    <i class="icon-cog"></i>
</button>

<div class="sidebar-filter-overlay" (click)="hideSidebar()"></div>